import {Injectable} from '@angular/core';
import {ICsDropDown} from '@app/shared/cs-components/cs-components.interface';
import {
    ICsIcon, ICsDdBasicTemplate, ICsPickerClickArg
} from '@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item.interface';
import {CsFaIcons, CsIconClasses, CsImages} from '@app/shared/cs-components/cs-images.';
import {
    TCsIconShape,
    TCsIconType, TCsPicker, TCsTimelineActivity
} from '@app/shared/cs-components/cs-components.types';
import {ICsDdGroupItem, ICsDdItem} from '@app/shared/cs-components/cs-drop-down/cs-drop-down.interface';
import * as moment from 'moment';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {BsDatepickerDirective} from 'ngx-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class CsActivityLogFilterConfigService {

    // Drop-down filters :
    dateRangeFilter: ICsDropDown;
    recordTypeFilter: ICsDropDown;
    userFilter: ICsDropDown;
    moduleFilter: ICsDropDown;

    mappedFilterConfigList = [];

    // Drop-down controls :
    addRecord: ICsDropDown;

    // Config Data :
    ISODateFormat = 'YYYY-MM-DD';
    dateSeparator = ':';
    existingAppliedFilters = {};

    recordConfig = {
        new_email: {type: 'EMAIL' as TCsTimelineActivity, iconSrc: CsFaIcons.email},
        new_sms: {type: 'SMS' as TCsTimelineActivity, iconSrc: CsFaIcons.sms},
        new_phone_call: {type: 'CALL' as TCsTimelineActivity, iconSrc: CsFaIcons.call},
        new_note: {type: 'NOTE' as TCsTimelineActivity, iconSrc: CsFaIcons.note},
        schedule_activity: {type: 'SCHEDULE_ACTIVITY' as TCsTimelineActivity, iconSrc: CsFaIcons.taskList}
    };

    constructor() {
    }

    getDdFilterConfigList(filterDataList) {
        this.mappedFilterConfigList = [];

        if (filterDataList) {
            filterDataList.forEach(filterItem => {
                // switch (item['identifier']) {
                if (filterItem['filters'] && filterItem['filters'].length) {
                    switch (filterItem['template_identifier']) {
                        case 'date_range':
                            // this.prepareDateRangeFilter(item);
                            this.mappedFilterConfigList.push(this.prepareDateRangeFilter(filterItem));
                            break;
                        case 'record_type':
                            // this.prepareRecordTypeFilter(item);
                            this.mappedFilterConfigList.push(this.prepareRecordTypeFilter(filterItem));
                            break;
                        case 'user':
                            // this.prepareUserFilter(item);
                            this.mappedFilterConfigList.push(this.prepareUserFilter(filterItem));
                            break;
                        case 'object':
                            // this.prepareModuleFilter(item);
                            this.mappedFilterConfigList.push(this.prepareModuleFilter(filterItem));
                            break;
                    }
                }
            });
        }

        // return [
        //     this.dateRangeFilter,
        //     this.recordTypeFilter,
        //     this.userFilter,
        //     this.moduleFilter
        // ];

        return this.mappedFilterConfigList;
    }

    getDdControlConfigList(controls) {
        this.prepareAddRecordControl(controls);

        return [
            this.addRecord
        ];
    }

    // Prepare drop-down Filters' config :

    prepareDateRangeFilter(filter) {
        if (filter['filters']['length']) {
            filter['filters'].unshift({
                name: 'All days',
                selected: false,
                show: true,
                uniq_identifier: '',
                identifier: 'all_days'
            });
        }

        this.dateRangeFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {text: filter['name']}
            },
            ddMenuConfig: {
                isSearchBar: true,
                templateType: 'BASIC',
                items: filter['filters'].map((item): ICsDdItem => {
                    this.setDateRange(item);
                    const mappedItem: ICsDdItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        isPicker: item['isPicker'] || null,
                        pickerConfig: {
                            _config: {
                                showWeekNumbers: false,
                                minDate: item['minDate'] || null,
                                maxDate: item['maxDate'] || null
                            },
                            placement: 'right'
                        } as BsDatepickerDirective,
                        pickerType: item['pickerType'] || null,
                        templateData: {
                            text: item['name']
                        }
                    };

                    this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };

        return this.dateRangeFilter;
    }

    prepareRecordTypeFilter(filter) {
        this.recordTypeFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {text: filter['name']}
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isGroupItem: true,
                isMultiChoice: true,
                groupItems: ((): ICsDdGroupItem[] => {
                    const groupObj = {};

                    filter['filters'].forEach(item => {
                        if (!groupObj[item['type']]) {
                            groupObj[item['type']] = {
                                id: item['type'],
                                title: item['type'],
                                items: []
                            };
                        }

                        groupObj[item['type']]['items'].push(((): ICsDdItem => {
                            const mappedItem: ICsDdItem = {
                                id: item['uniq_identifier'],
                                filterId: item['uniq_identifier'],
                                ddConfigId: filter['identifier'],
                                isSelected: item['selected'],
                                templateData: {
                                    text: item['name'],
                                    iconsList: [
                                        this.getIconConfig(
                                            'check_box',
                                            CsIconClasses.squareCheckBox,
                                            false,
                                            'CLASS_ICON'),

                                        // ((): ICsIcon => {
                                        //     switch (item['identifier']) {
                                        //         case 'call':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.call);
                                        //         case 'sms':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.sms);
                                        //         case 'email':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.email);
                                        //         case 'note':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.note);
                                        //         case 'meeting':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.calendar);
                                        //         case 'workflow_trigger':
                                        //             return this.getIconConfig(item['identifier'], CsFaIcons.link);
                                        //
                                        //         default:
                                        //             return this.getIconConfig(item['identifier'], '');
                                        //     }
                                        // })()
                                    ]
                                }
                            };

                            this.setExistingAppliedFilters(mappedItem, true);
                            return mappedItem;
                        })());
                    });

                    return Object.values(groupObj);
                })()
            }
        };

        return this.recordTypeFilter;
    }

    prepareUserFilter(filter) {
        if (filter['filters']['length']) {
            filter['filters'].unshift({
                name: 'All users',
                selected: false,
                show: true,
                uniq_identifier: '',
                profile: '',
                identifier: ''
            });
        }

        this.userFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {text: filter['name']}
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isSearchBar: true,
                items: filter['filters'].map((item): ICsDdItem => {
                    const mappedItem: ICsDdItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        templateData: {
                            text: item['name'],
                            iconsList: [
                                (() => this.getIconConfig(
                                        'profile_pic',
                                        item['profile'] || CsImages.userProfile,
                                        false,
                                        'IMAGE',
                                        'CIRCLE')
                                )()
                            ]
                        }
                    };

                    this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };

        return this.userFilter;
    }

    prepareModuleFilter(filter) {
        this.moduleFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {text: filter['name']}
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                items: filter['filters'].map((item): ICsDdItem => {
                    const mappedItem: ICsDdItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        templateData: {
                            text: item['name']
                        }
                    };

                    this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };

        return this.moduleFilter;
    }

    // Prepare drop-down Controls' config :

    prepareAddRecordControl(controlList) {
        this.addRecord = {
            id: 'add_record',
            ddTogglerConfig: {
                templateType: 'BTN_PRIMARY',
                togglerType: 'SOLID',
                templateData: {
                    text: 'Add record'
                }
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isMultiChoice: true,
                gridColumns: 2,
                items: (() => {
                    return controlList.map(record => {
                        if (this.recordConfig[record['identifier']]) {
                            return (<ICsDdItem>{
                                id: record['identifier'],
                                type: this.recordConfig[record['identifier']].type,
                                isDisableItemClick: true,
                                isFavourite: record['favorite'],
                                templateData: (() => {
                                    return <ICsDdBasicTemplate>{
                                        text: record['name'],
                                        isTextClick: true,
                                        isDdMenuHide: true,
                                        iconsList: [
                                            this.getIconConfig(
                                                `fav`,
                                                record['favorite'] ? CsFaIcons.starSolid : CsFaIcons.starRegular,
                                                true,
                                                'FA_ICON',
                                                'BOX',
                                                false,
                                                true),
                                            this.getIconConfig(
                                                `${record.id}_icon`,
                                                this.recordConfig[record['identifier']].iconSrc,
                                                false,
                                                'FA_ICON',
                                                'BOX',
                                                true)
                                        ]
                                    };
                                })()
                            });
                        }
                    }).filter(item => item);
                })()
            }
        };
    }

    // Helper functions :

    getIconConfig(
        iconId: number | string,
        iconSrc: string,
        isIconClick = false,
        srcType: TCsIconType = 'FA_ICON',
        shape: TCsIconShape = 'BOX',
        isItemIndicator = false,
        isFavIndicator = false): ICsIcon {
        return ({
            id: iconId,
            src: iconSrc,
            type: srcType,
            shape: shape,
            isIconClick: isIconClick,
            isFavouriteIndicator: isFavIndicator,
            isItemIndicator: isItemIndicator
        });
    }

    setExistingAppliedFilters(filterItem: ICsDdItem, isMultiChoice?: boolean) {
        if (filterItem.isSelected) {
            if (this.existingAppliedFilters[filterItem.ddConfigId]) {
                if (isMultiChoice) {
                    this.existingAppliedFilters[filterItem.ddConfigId].push(filterItem.filterId);
                } else {
                    this.existingAppliedFilters[filterItem.ddConfigId] = [filterItem.filterId];
                }
            } else {
                this.existingAppliedFilters[filterItem.ddConfigId] = [filterItem.filterId];
            }
        }
    }

    getExistingAppliedFilters() {
        return this.existingAppliedFilters;
    }

    setDateRange(item) {
        const currentDate = Date.now()
            , itemId = item['identifier'].toLowerCase();

        // let fromDt, toDt;

        // Note: Here `item['identifier']` comes from API, So handled cases according that.

        switch (itemId) {
            // case 'today' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).format(this.ISODateFormat)}`;
            //     break;
            // case 'yesterday' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).subtract(1, 'day').format(this.ISODateFormat)}`;
            //     break;
            // case 'tomorrow' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).add(1, 'day').format(this.ISODateFormat)}`;
            //     break;
            // case 'this_week' :
            //     fromDt = moment(currentDate).subtract(0, 'weeks').startOf('week').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(0, 'weeks').endOf('week').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_week' :
            //     fromDt = moment(currentDate).subtract(1, 'weeks').startOf('week').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'weeks').endOf('week').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_month' :
            //     fromDt = moment(currentDate).subtract(1, 'months').startOf('month').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'months').endOf('month').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_quarter' :
            //     const quarterMonth = (moment().month() % 3) + 1;
            //     const lastQuarterEndDate = moment().subtract({months: quarterMonth}).endOf('month');
            //     const lastQuarterStartDate = lastQuarterEndDate.clone().subtract({months: 3}).startOf('month').format(this.ISODateFormat);
            //
            //     fromDt = lastQuarterStartDate;
            //     toDt = lastQuarterEndDate.format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_year' :
            //     fromDt = moment(currentDate).subtract(1, 'year').startOf('year').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'year').endOf('year').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;

            case 'bt_' :
                item['isPicker'] = true;
                item['pickerType'] = 'DATE_RANGE' as TCsPicker;
                break;

            case 'before_' :
            case 'after_' :
                item['isPicker'] = true;
                item['pickerType'] = 'DATE' as TCsPicker;
                item[itemId === 'before_' ? 'maxDate' : 'minDate'] = new Date();
                break;
        }
    }

    doPickerAction(data: ICsPickerClickArg) {
        switch (data.type) {
            case 'DATE':
                data.item.filterId = data.item.id + moment(data.val).format(this.ISODateFormat);
                break;

            case 'DATE_RANGE':
                const fromDt = moment(data.val[0]).format(this.ISODateFormat);
                const toDt = moment(data.val[1]).format(this.ISODateFormat);
                data.item.filterId = data.item.id + fromDt + this.dateSeparator + toDt;
                break;
        }
    }

    resetExistingAppliedFilters() {
        this.existingAppliedFilters = {};
    }
}
